

import React, { useEffect, useState } from "react";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,

  TableRow,
  Paper,
  IconButton,
  Collapse,
  Divider,
  Tooltip,
  Dialog,
  DialogContent,
  DialogTitle
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  ExpandMore,
  ExpandLess
} from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import { FormatDateShort } from "../../utils/common/DateUtils";
import { useSelector } from "react-redux";
import { CON_DEFAULT_IMG, CON_STATUS_ACTIVE, CON_STATUS_RETURN_SUBMITTED, CON_STATUS_RETURNAPPROVED, CON_STATUS_RETURNREJECTED, CON_STATUS_RETURNSAVED, CON_STATUS_RETURNSUBMITTED } from "../../utils/sys/Constants";
import { externalgetApi } from "../../services/externalApis";
import { SETTING_API_03, SETTING_API_05, SETTING_API_09 } from "../../api/ApiModel";
import {
  FormatCurrencyLKR,
  formatWithCommas,
} from "../../utils/common/CurrencyFormatter";
import ImagePopUp from "../grn/grnpopup/ImagePopUp";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { RETURN_STATUS_CODE } from "../../utils/sys/GrnConstants";

const  ViewDataGridGrnDetailsreturn = ({ grnItems, grnReturns, grnData = [] }) => {
  // console.log("grnItems returnnnnnnn", grnReturns);
  const theme = useTheme();
  const styles = useStyles(theme);
  const [imagePreviewOpen, setImagePreviewOpen] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState(null);
  const [expanded, setExpanded] = useState([]);
  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, STAFFMAPLOCODE } = SYS_USER.USER_PARAM || {};
 const [grnDocTypes, setGrnDocTypes] = useState([]);
  const [expandedId, setExpandedId] = useState(null);
 const grnItemsData = Array.isArray(grnData?.products)
  ? grnData.products.filter((item) => item.isAdded === true)
  : (grnItems || []);


  console.log("grnItemsData itemAttachments:", grnItemsData.map((item, idx) => ({
  index: idx,
  productname: item.productname,
  attachments: item.itemAttachments?.attachments || [],
})));


  const grnReturnsData = grnReturns || {};
  const [mouList, setMouList] = useState([]);
  const [open, setOpen] = useState(false); // State to manage dialog visibility

  const handleExpandClick = (index) => {
    setExpanded((prev) => {
      const newExpanded = prev.map(() => false);
      newExpanded[index] = true;
      return newExpanded;
    });
  };

  const getMouNameByCode = (code) => {
    const mou = mouList.find((b) => b.immeasuringunitcode === code);
    return mou ? mou.immeasuringunit : "No-MOU";
  };
  const isImage = (filename) => {
    return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filename);
  };

  const handleOpen = () => {
    setOpen(true); // Open the dialog
  };

  const handleClose = () => {
    setOpen(false); // Close the dialog
  };

  useEffect(() => {
    fetchMou();
  }, []);

  const fetchMou = async () => {
    try {
      const params = {
        COMPCODE,
        LOCCODE: STAFFMAPLOCODE,
        STS: CON_STATUS_ACTIVE,
      };
      const response = await externalgetApi(SETTING_API_05, "GET", params);
      setMouList(response || []);
    } catch (error) {
      console.error("Error fetching brands:", error);
      setMouList([]);
    }
  };

  const sourceData =
    Array.isArray(grnReturnsData) && grnReturnsData.length > 0
      ? grnReturnsData
      : Array.isArray(grnItemsData) && grnItemsData.length > 0
      ? grnItemsData
      : [];
const filteredRejectItems = sourceData.filter((item) => {
  const sts = String(item?.sts).trim();
  return (
   
    sts !== "" &&
    sts !== "null" &&
    sts !== "undefined"
  );
});


  useEffect(() => {
    fetchGrnDocCategory();
  }, [])
  
    const fetchGrnDocCategory = async () => {
      try {
        const params = { STS: CON_STATUS_ACTIVE };
        const response = await externalgetApi(SETTING_API_09,"GET", params);
        const grnCategory = response.find((cat) => cat.doccatname === "Item-Based Document Types");
  
        if (grnCategory) {
          fetchGrnDocType(grnCategory.doccatcode);
        }
        console.log("grnCategory", grnCategory);
      } catch (error) {
        console.error("Error fetching GRN document category", error);
      }
    };

    // Add this inside your component
const getDocTypeName = (code) => {
  const found = grnDocTypes.find(
    (doc) => String(doc.doctypecode) === String(code)
  );
  return found ? found.doctype : code || "-";
};
  
    const fetchGrnDocType = async (docCatCode) => {
      try {
        const params = {
          COMPCODE,
          LOCCODE: STAFFMAPLOCODE,
          DOCCATCODE: docCatCode,
          STS: CON_STATUS_ACTIVE,
        };
        const response = await externalgetApi(SETTING_API_03, "GET", params);
        setGrnDocTypes(response); // Save doc types to state
         console.log("grnDocTypes", response);
      } catch (error) {
        console.error("Error fetching GRN document types", error);
      }
    };
  // console.log("yy rejectedItems", filteredRejectItems);

  return (
    <>
      <TableContainer component={Paper} sx={styles.grn_table_container}>
        <Table>
          <TableHead>
            <TableRow sx={styles.grn_table_header_row}>
              <TableCell sx={styles.grn_table_header_col_first}></TableCell>
              <TableCell sx={styles.grn_table_header_col_first}>
                <Box sx={styles.grn_table_header_col_box}>Image</Box>
              </TableCell>

              <TableCell sx={styles.grn_table_header_col}>
                <Box sx={styles.grn_table_header_col_box}>Item Details</Box>
              </TableCell>
              <TableCell sx={styles.grn_table_header_col}>
                <Box sx={styles.grn_table_header_col_box}>
                  Date & Measurements
                </Box>
              </TableCell>
              <TableCell sx={styles.grn_table_header_col}>
                <Box sx={styles.grn_table_header_col_box}>Quantity</Box>
              </TableCell>
              <TableCell sx={styles.grn_table_header_col}>
                <Box sx={styles.grn_table_header_col_box}>Amount (LKR)</Box>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {grnItemsData.map((item, index) => {
              const isExpanded = expandedId === item.id;

              const rejectItem = grnReturnsData.find(
                (ret) => ret.productcode === item.productcode
              );
// ...existing code...

// Parse docpathjson as array of attachments
let parsedDocPathJson = [];
try {
  parsedDocPathJson = item?.docpathjson
    ? JSON.parse(item.docpathjson)
    : [];
} catch (e) {
  parsedDocPathJson = [];
}

// Flatten attachments from itemAttachments?.attachments
let itemAttachmentsArray = [];
if (Array.isArray(item.itemAttachments?.attachments)) {
  itemAttachmentsArray = item.itemAttachments.attachments;
}

// ✅ Normalize function
const normalizeAttachment = (att) => {
  const filename = att.filename || att.FILENAME || "";
  const base64 = att.docpathjson || att.bytarr || "";
  let FILEPATH = att.objectUrl || att.fileUrl || "";

  // If no FILEPATH and base64 exists, build a data URL for images
  if (!FILEPATH && base64) {
    const isImg = /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filename);
    FILEPATH = isImg
      ? `data:image/${filename.split(".").pop() || "jpeg"};base64,${base64}`
      : `data:application/octet-stream;base64,${base64}`;
  }

  return {
    ...att,
    FILEPATH,
    FILENAME: filename,
    DOCTYPECODE: String(att.doctypecode || att.DOCTYPECODE || "0"),
    DOCTYPE: att.doctypename || att.DOCTYPENAME || att.doctype || "",
    REMARK: att.remark || att.REMARK || att.docremark || "",
    doctypeothername: att.doctypeothername || att.DOCTYPEOTHERNAME || "",
  };
};

// ✅ Combine and normalize
const combinedAttachments = [
  ...itemAttachmentsArray.map(normalizeAttachment),
  ...parsedDocPathJson,
];

// ✅ Filter out DOCTYPECODE === "0"
const filteredAttachments = combinedAttachments.filter(
  (att) =>
    att?.DOCTYPECODE &&
    att.DOCTYPECODE !== "0" &&
    att.DOCTYPECODE.trim() !== "" &&
    att.FILEPATH && att.FILEPATH.trim() !== ""   // <-- ADD THIS
);


console.log("filteredAttachments", filteredAttachments);

// ...use combinedAttachments in your render as before...

              // console.log("itemAttachmentsArray", itemAttachmentsArray);

              const base64Attachments = item?.rejectItem?.attachments || [];

              const grnReturnAttachments = rejectItem?.docpathjson
                ? (() => {
                    try {
                      return JSON.parse(rejectItem.docpathjson);
                    } catch (e) {
                      console.error(
                        "Invalid JSON in rejectItem.docpathjson:",
                        e
                      );
                      return [];
                    }
                  })()
                : [];

              const attachmentsToShow =
                grnReturnAttachments.length > 0
                  ? grnReturnAttachments
                  : base64Attachments;

const getSts7Attachments = (grnReturnsData) => {
  if (!Array.isArray(grnReturnsData)) return [];

  const allowedStatuses = RETURN_STATUS_CODE;

  return grnReturnsData
    .filter(
      (item) =>
        allowedStatuses.includes(String(item.sts)) && item.docpathjson // ✅ ensure it's `sts` (not `trsts`)
    )
    .slice(0,1)
    .flatMap((item) => {
      try {
        const attachments = JSON.parse(item.docpathjson);
        return attachments.map((attachment) => ({
          ...attachment,
          productcode: item.productcode,
          supproductcode: item.supproductcode,
        }));
      } catch (err) {
        console.warn("Invalid JSON in docpathjson:", item.docpathjson);
        return [];
      }
    });
};

const ReturnAttachmentsToShow = getSts7Attachments(grnReturnsData);


              console.log("ReturnAttachmentsToShow", ReturnAttachmentsToShow);
              console.log("grnReturnsData", grnReturnsData);
              // console.log("attachmentsToShow", attachmentsToShow);
              // console.log("rejectItem", rejectItem);
              // console.log("combinedAttachments", combinedAttachments);
              return (
                <React.Fragment key={(item.id, index)}>
                  <TableRow
                    key={item.id}
                    sx={{
                      backgroundColor: isExpanded
                        ? theme.palette.background.bgShade_3
                        : "inherit",
                    }}
                  >
                    <TableCell sx={styles.grn_table_row_expand}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignContent: "center",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: "1px",
                        }}
                      >
                        <Box sx={{ ...styles.grn_table_row_expand_container }}>
                          <IconButton
                            size="small"
                            // onClick={() => handleExpandClick(item.id)}
                            onClick={() => handleExpandClick(index)}
                          >
                            {/* {isExpanded ? <ExpandLess /> : <ExpandMore />} */}
                            {expanded[index] ? <ExpandLess /> : <ExpandMore />}
                          </IconButton>
                        </Box>
                      </Box>
                    </TableCell>

                    {/* Image */}
                    <TableCell
                      sx={{
                        px: 3,
                        py: 1,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: 48,
                          width: 48,
                          overflow: "hidden",
                          borderRadius: 1,
                          border: "1px solid #ddd",
                        }}
                      >
                        <img
                          src={item.imagepath}
                          alt={`${item.productname} image`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                          loading="lazy"
                          onClick={handleOpen}
                        />

                        <Dialog open={open} onClose={handleClose} minWidth="sm">
                          <DialogTitle>
                            {item.productname}
                            <IconButton
                              aria-label="close"
                              onClick={handleClose}
                              style={{
                                position: "absolute",
                                right: 8,
                                top: 8,
                              }}
                            >
                              <CloseIcon />
                            </IconButton>
                          </DialogTitle>
                          <DialogContent>
                            <img
                              src={item.imagepath}
                              alt={`${item.productname} image`}
                              style={{
                                width: "auto",
                                height: "auto",
                                objectFit: "contain",
                              }}
                            />
                          </DialogContent>
                        </Dialog>
                      </Box>
                    </TableCell>

                    {/* Item Details */}
                    <TableCell sx={styles.common_cell_style_2}>
                      <Box sx={styles.grn_table_body_col_box}>
                        <Box sx={styles.grn_table_body_col_box_row}>
                          <Typography sx={styles.grn_table_row}>
                            {item.productname || "-"}
                          </Typography>
                        </Box>
                        <Box sx={styles.grn_table_body_col_box_row}>
                          <Typography sx={styles.grn_table_row_title}>
                            Item Code : {item.productcode || "-"}
                          </Typography>
                        </Box>
                      </Box>
                      <Collapse
                        in={expanded[index]}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Box sx={styles.vd_cell_collapse_box}>
                          <Box sx={styles.grn_table_body_col_box_row}>
                            <Typography sx={styles.grn_table_row_title}>
                              Brand : {item.brandname || "-"}
                            </Typography>
                          </Box>
                          <Box sx={styles.grn_table_body_col_box_row}>
                            <Typography sx={styles.grn_table_row_title}>
                              Batch Number : {item.batchno || "-"}
                            </Typography>
                          </Box>
                        </Box>
                      </Collapse>
                    </TableCell>

                    {/* Date & Measurements */}
                    <TableCell sx={styles.common_cell_style_2}>
                      <Box sx={styles.grn_table_body_col_box}>
                        <Box sx={styles.grn_table_body_col_box_row}>
                          <Typography sx={styles.grn_table_row_title_name}>
                            UOM :
                          </Typography>
                          <Typography sx={styles.grn_table_row_title_value}>
                            {item?.immeasuringunit ||
                              getMouNameByCode(item?.immeasuringunitcode) ||
                              "-"}
                          </Typography>
                        </Box>
                        <Box sx={styles.grn_table_body_col_box_row}>
                          <Typography sx={styles.grn_table_row_title_name}>
                            Size :
                          </Typography>
                          <Typography sx={styles.grn_table_row_title_value}>
                            {item.productsize || "-"}
                          </Typography>
                        </Box>
                      </Box>
                      <Collapse
                        in={expanded[index]}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Box sx={styles.vd_cell_collapse_box}>
                          <Box sx={styles.grn_table_body_col_box_row}>
                            <Typography sx={styles.grn_table_row_title_name}>
                              MFD :
                            </Typography>
                            <Typography sx={styles.grn_table_row_title_value}>
                         {item?.manufacdate  &&
                                                            item.manufacdate  !== "0001-01-01T00:00:00"
                                                              ? FormatDateShort(item.manufacdate)
                                                              : "-"}
                            </Typography>
                          </Box>
                          <Box sx={styles.grn_table_body_col_box_row}>
                            <Typography sx={styles.grn_table_row_title_name}>
                              EXP :
                            </Typography>
                            <Typography sx={styles.grn_table_row_title_value}>
                              {/* {FormatDateShort(item?.expdate) || "-"} */}
                                                          {item?.expdate &&
                                                          item?.expdate !== "0001-01-01T00:00:00"
                                                            ? FormatDateShort(item?.expdate)
                                                            : "-"}
                            </Typography>
                          </Box>
                        </Box>
                      </Collapse>
                    </TableCell>
                    {/* Quantity */}
                    <TableCell sx={styles.common_cell_style_2}>
                      <Box sx={styles.grn_table_body_col_box}>
                        <Box sx={styles.grn_table_body_col_box_row}>
                          <Typography sx={styles.grn_table_row_title_name}>
                            Accepted Quantity :
                          </Typography>
                          <Typography sx={styles.grn_table_row_title_value}>
                            {formatWithCommas(item.acceptedqty) || "-"}
                          </Typography>
                        </Box>
                        <Box sx={styles.grn_table_body_col_box_row}>
                          <Typography sx={styles.grn_table_row_title_name}>
                            PO Quantity :
                          </Typography>
                          <Typography sx={styles.grn_table_row_title_value}>
                            {formatWithCommas(item.poqty) || "-"}
                          </Typography>
                        </Box>
                      </Box>
                      <Collapse
                        in={expanded[index]}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Box sx={styles.vd_cell_collapse_box}>
                          <Box sx={styles.grn_table_body_col_box_row}>
                            <Typography sx={styles.grn_table_row_title_name}>
                             Pending PO Quantity :
                            </Typography>
                            <Typography sx={styles.grn_table_row_title_value}>
                              {/* {formatWithCommas(item.quantitydifference) || "-"} */}
                              {formatWithCommas(
                                (parseFloat(item.poqty) || 0) -
                                  ((parseFloat(item.receivedqty) || 0) -
                                    (parseFloat(
                                      rejectItem?.returnedqty ||
                                        item.rejectItem?.returnedqty
                                    ) || 0))
                              ) || "-"}
                            </Typography>
                          </Box>
                          <Box sx={styles.grn_table_body_col_box_row}>
                            <Typography sx={styles.grn_table_row_title_name}>
                              Received Quantity :
                            </Typography>
                            <Typography sx={styles.grn_table_row_title_value}>
                              {formatWithCommas(item.receivedqty) || "-"}
                            </Typography>
                          </Box>
                        </Box>
                      </Collapse>
                    </TableCell>

                    {/* Amount (LKR) */}
                    <TableCell sx={styles.common_cell_style_2}>
                      <Box sx={styles.grn_table_body_col_box}>
                        <Box sx={styles.grn_table_body_col_box_row}>
                          <Typography sx={styles.grn_table_row_title_name}>
                           Value :
                          </Typography>
                          <Typography sx={styles.grn_table_row_title_value}>
                            {FormatCurrencyLKR(item.grossvalue) || "-"}
                          </Typography>
                        </Box>
                        <Box sx={styles.grn_table_body_col_box_row}>
                          <Typography sx={styles.grn_table_row_title_name}>
                            Unit Price :
                          </Typography>
                          <Typography sx={styles.grn_table_row_title_value}>
                            {FormatCurrencyLKR(item.unitprice) || "-"}
                          </Typography>
                        </Box>
                      </Box>
                      <Collapse
                        in={expanded[index]}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Box sx={styles.vd_cell_collapse_box}>
                          <Box sx={styles.grn_table_body_col_box_row}>
                            <Typography sx={styles.grn_table_row_title_name}>
                              Discount Value :
                            </Typography>
                            <Typography sx={styles.grn_table_row_title_value}>
                              {FormatCurrencyLKR(item.discountvalue) || "-"}
                            </Typography>
                          </Box>
                          <Box sx={styles.grn_table_body_col_box_row}>
                            <Typography sx={styles.grn_table_row_title}>
                              Tax Rate(%) : {item.taxrate || "-"}
                            </Typography>
                            <Typography sx={styles.grn_table_row_title}>
                              Tax Value :{" "}
                              {FormatCurrencyLKR(item.taxvalue) || "-"}
                            </Typography>
                          </Box>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>

                  {/* Return Items TT */}
                {Array.isArray(grnReturnsData) &&
  grnReturnsData.length > 0 &&
  grnReturnsData.some((item) => [CON_STATUS_RETURNSUBMITTED, CON_STATUS_RETURNAPPROVED, CON_STATUS_RETURNREJECTED, CON_STATUS_RETURNSAVED,CON_STATUS_RETURN_SUBMITTED].includes(item.sts)) &&
  grnReturnsData
    .filter((ret) => [CON_STATUS_RETURNSUBMITTED, CON_STATUS_RETURNAPPROVED, CON_STATUS_RETURNREJECTED, CON_STATUS_RETURNSAVED,CON_STATUS_RETURN_SUBMITTED].includes(ret.sts) && ret.productcode === item.productcode)
    .map((retItem, idx) => {
      const originalItem = grnItemsData.find(prod => prod.productcode === retItem.productcode);

      const unitPrice = parseFloat(retItem.unitprice ?? originalItem?.unitprice ?? 0);
      const unitCost = parseFloat(retItem.perunittaxableamount ?? originalItem?.perunittaxableamount ?? 0) +
                       parseFloat(retItem.perunitchargevalue ?? originalItem?.perunitchargevalue ?? 0);
      const taxRate = parseFloat(retItem.taxrate ?? originalItem?.taxrate ?? 0);
      const taxPerUnit = parseFloat(retItem.perunittaxvalue ?? originalItem?.perunittaxvalue ?? 0) || 0;
      const returnedQty = parseFloat(retItem.rejectItem?.returnedqty ?? retItem.returnedqty ?? 0) || 0;
      const acceptedQty = parseFloat(originalItem?.acceptedqty ?? 0) || 0;
const freeqty = parseFloat(originalItem?.freeqty ?? 0) || 0;
      return (
        <TableRow key={idx}>
          <TableCell colSpan={7} sx={styles.grn_table_expand_cell}>
            <Collapse in={expanded[index]} timeout="auto" unmountOnExit>
              <Box sx={{ m: 1, py: 0, pl: 5 }}>
                <Box sx={styles.grn_table_expand_cell_container_title}>
                  <Typography sx={styles.grn_table_row}>Return Items</Typography>
                </Box>

                <Grid container spacing={2} sx={styles.grn_table_expand_cell_grid}>
                  {/* Return Quantity */}
                  <Grid item size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}>
                    <Box sx={styles.grn_action_items_box}>
                      <Typography sx={styles.grn_table_row_title}>Return Quantity :</Typography>
                      <Typography sx={styles.grn_table_row}>{returnedQty || "-"}</Typography>
                    </Box>
                  </Grid>

                  {/* Reason */}
                  <Grid item size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}>
                    <Box sx={styles.grn_action_items_box}>
                      <Typography sx={styles.grn_table_row_title}>Reason :</Typography>
                      <Typography sx={styles.grn_table_row}>{retItem.rejectItem?.reason ?? retItem.reason ?? "-"}</Typography>
                    </Box>
                  </Grid>

                  {/* Remark */}
                <Grid item size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}>
  <Box sx={styles.grn_action_items_box}>
    <Typography sx={styles.grn_table_row_title}>Remark :</Typography>

    {/* Find first matching attachment with a remark */}
    {(() => {
      const matchingAttachment = ReturnAttachmentsToShow.find(
        (att) =>
          (att.productcode === retItem.productcode ||
            att.supproductcode === retItem.supproductcode) &&
          att.REMARK &&
          att.REMARK.trim() !== ""
      );
    // ✅ Prefer attachment remark, fallback to retItem.descrip or "-"
    const displayRemark =
      matchingAttachment?.REMARK || retItem?.descrip || "-";

    return <Typography sx={styles.grn_table_row}>{displayRemark}</Typography>;
    })()}
  </Box>
</Grid>


                  {/* Attachments */}
              <Grid
  item
  size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}
>
  <Box sx={styles.grn_action_items_box}>
    <Typography sx={styles.grn_table_row_title}>Attachments :</Typography>

{ReturnAttachmentsToShow
  .filter(
    (att) =>
      (att.productcode === retItem.productcode ||
        att.supproductcode === retItem.supproductcode) &&
      att.FILEPATH !== CON_DEFAULT_IMG
  )
  
  .map((attachment, index) => (
    <Box
      key={index}
      display="flex"
      flexDirection="column"
      alignItems="center"
      bgcolor="background.paper"
      borderRadius={1}
      sx={{ boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.1)" }}
      p={1}
      m={0.5}
    >
      <Tooltip
        title={
          attachment?.FILENAME ??
          attachment?.filename ??
          attachment?.FILEPATH
        }
        placement="bottom"
      >
        {isImage(
          attachment?.FILENAME ??
            attachment?.filename ??
            attachment?.FILEPATH
        ) ? (
          <img
            src={attachment?.FILEPATH}
            alt={attachment?.FILENAME ?? "Attachment"}
            style={{
              width: 24,
              height: 24,
              objectFit: "cover",
              cursor: "pointer",
            }}
            onClick={() => {
              setSelectedImage({
                url: attachment?.FILEPATH,
                name: attachment?.FILENAME || "",
                description: attachment?.REMARK || "",
              });
              setImagePreviewOpen(true);
            }}
          />
        ) : (
          <InsertDriveFileIcon
            alt="Document icon"
            style={{ width: 24, height: 24, cursor: "pointer" }}
            onClick={() => window.open(attachment?.FILEPATH, "_blank")}
          />
        )}
      </Tooltip>
    </Box>
  ))}

  </Box>
</Grid>
  <Grid item size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}>
                    <Box sx={styles.grn_action_items_box}>
                      <Typography sx={styles.grn_table_row_title}>Total Quantity:</Typography>
                      <Typography sx={styles.grn_table_row}>{(acceptedQty)+(freeqty)}</Typography>
                    </Box>
                  </Grid>

                  {/* Unit Cost / Total Before Tax / Tax per Unit / Total Tax / Total */}
                  <Grid item size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}>
                    <Box sx={styles.grn_action_items_box}>
                      <Typography sx={styles.grn_table_row_title}>Unit Cost:</Typography>
                      <Typography sx={styles.grn_table_row}>{FormatCurrencyLKR(unitCost)}</Typography>
  </Box>
                  </Grid>

                

                  <Grid item size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}>
                    <Box sx={styles.grn_action_items_box}>
                      <Typography sx={styles.grn_table_row_title}>  Tax (%) :</Typography>
                      <Typography sx={styles.grn_table_row}>{(taxRate)}%</Typography>
                    </Box>
                  </Grid>

                  <Grid item size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}>
                    <Box sx={styles.grn_action_items_box}>
                      <Typography sx={styles.grn_table_row_title}> Tax per Unit :</Typography>
                      <Typography sx={styles.grn_table_row}>{FormatCurrencyLKR(taxPerUnit)}</Typography>
                    </Box>
                  </Grid>

                
                </Grid>
              </Box>
              <Divider />
            </Collapse>
          </TableCell>
        </TableRow>
      );
    })
}

                  {/* Reject Items */}
         {(() => {
  // Filter reject items for the current product
  const productRejectItems = filteredRejectItems.filter(
    (rej) => rej.productcode === item.productcode
  );

  // Take only the first reject item if it exists
  const rejectItem = productRejectItems[0] || {};

  console.log("rejectItem attachments", rejectItem);

  // Filter attachments to skip DOCTYPECODE = "0"
  const validAttachments = attachmentsToShow.filter(
    (att) => String(att.DOCTYPECODE) !== "0"
  );

  return (
    <TableRow>
      <TableCell colSpan={7} sx={styles.grn_table_expand_cell}>
        <Collapse in={expanded[index]} timeout="auto" unmountOnExit>
          <Box sx={{ m: 1, py: 0, pl: 5 }}>
            <Box sx={styles.grn_table_expand_cell_container_title}>
              <Typography sx={styles.grn_table_row}>Reject Items</Typography>
            </Box>

            <Grid container spacing={2} sx={styles.grn_table_expand_cell_grid}>
              <Grid item size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}>
                <Box sx={styles.grn_action_items_box}>
                  <Typography sx={styles.grn_table_row_title}>Reject Quantity :</Typography>
                  <Typography sx={styles.grn_table_row}>
                    {rejectItem.returnedqty || rejectItem.rejectItem?.returnedqty || "-"}
                  </Typography>
                </Box>
              </Grid>

              <Grid item size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}>
                <Box sx={styles.grn_action_items_box}>
                  <Typography sx={styles.grn_table_row_title}>Reason :</Typography>
                  <Typography sx={styles.grn_table_row}>
                    {rejectItem.reason || rejectItem.rejectItem?.reason || "-"}
                  </Typography>
                </Box>
              </Grid>

              <Grid item size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}>
                <Box sx={styles.grn_action_items_box}>
                  <Typography sx={styles.grn_table_row_title}>Remarks :</Typography>
                  <Typography sx={styles.grn_table_row}>
                    {rejectItem.descrip || rejectItem.rejectItem?.descrip || "-"}
                  </Typography>
                </Box>
              </Grid>

              <Grid item size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}>
                <Box sx={styles.grn_action_items_box}>
                  <Typography sx={styles.grn_table_row_title}>Attachments :</Typography>

                  {validAttachments.map((attachment, idx) => {
                    const imageSrc =
                      attachment.objectUrl ||
                      attachment.fileUrl ||
                      (attachment.docpathjson && `data:image/png;base64,${attachment.docpathjson}`) ||
                      attachment.FILEPATH;

                    const isImg = isImage(
                      attachment.filename || attachment.FILENAME || attachment.FILEPATH
                    );

                    return (
                      <Box
                        key={idx}
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        bgcolor="background.paper"
                        borderRadius={1}
                        sx={{ boxShadow: `0px 1px 2px rgba(0, 0, 0, 0.1)` }}
                        p={1}
                      >
                        {isImg ? (
                          <Tooltip
                            title={attachment.filename || attachment.FILENAME}
                            placement="bottom"
                          >
                            <img
                              src={imageSrc}
                              alt={attachment.filename || attachment.FILENAME || "Attachment"}
                              style={{ width: 24, height: 24, objectFit: "cover", cursor: "pointer" }}
                              onClick={() => {
                                setSelectedImage({
                                  url: imageSrc,
                                  name: attachment.FILENAME || "Image",
                                  description: attachment.REMARK || "",
                                  objectUrl: attachment.objectUrl || "",
                                });
                                setImagePreviewOpen(true);
                              }}
                            />
                          </Tooltip>
                        ) : (
                          <InsertDriveFileIcon
                            alt="Document icon"
                            style={{ width: 20, height: 20 }}
                            onClick={() => {
                              setSelectedImage({
                                url: imageSrc,
                                name: attachment.FILENAME || "Document",
                                description: attachment.REMARK || "",
                                objectUrl: attachment.objectUrl || "",
                              });
                              setImagePreviewOpen(true);
                            }}
                          />
                        )}
                      </Box>
                    );
                  })}
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Divider />
        </Collapse>
      </TableCell>
    </TableRow>
  );
})()}


                  {/* Foc items */}
                  <TableRow>
                    <TableCell colSpan={7} sx={styles.grn_table_expand_cell}>
                      <Collapse
                        in={expanded[index]}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Box
                          sx={{
                            m: 1,
                            py: 0,
                            pl: 5,
                          }}
                        >
                          <Box
                            sx={styles.grn_table_expand_cell_container_title}
                          >
                            <Typography sx={styles.grn_table_row}>
                              FOC Items
                            </Typography>
                          </Box>
                          <Grid
                            container
                            spacing={2}
                            sx={styles.grn_table_expand_cell_grid}
                          >
                            <Grid
                              item
                              size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}
                            >
                              <Box sx={styles.grn_action_items_box}>
                                <Typography sx={styles.grn_table_row_title}>
                                  FOC Quantity :
                                </Typography>
                                <Typography sx={styles.grn_table_row}>
                                  {item.freeqty || "-"}
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid
                              item
                              size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}
                            >
                              <Box sx={styles.grn_action_items_box}>
                                <Typography sx={styles.grn_table_row_title}>
                                  Remark :
                                </Typography>
                                <Typography sx={styles.grn_table_row}>
                                  {item.descrip || "-"}
                                </Typography>
                              </Box>
                            </Grid>{" "}
                          </Grid>
                        </Box>
                        <Divider />
                      </Collapse>
                    </TableCell>
                  </TableRow>

                  {/*  Attachments */}
                  <TableRow>
                    <TableCell colSpan={7} sx={styles.grn_table_expand_cell}>
                      <Collapse
                        in={expanded[index]}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Box
                          sx={{
                            m: 1,
                            py: 0,
                            pl: 5,
                          }}
                        >
                          <Box
                            sx={styles.grn_table_expand_cell_container_title}
                          >
                            <Typography sx={styles.grn_table_row}>
                              Attachments
                            </Typography>
                          </Box>
                       {filteredAttachments && filteredAttachments.length > 0 ? (
  filteredAttachments.map(
    (attachment, index) =>
      attachment && (
        <Grid
          key={index}
          container
          spacing={2}
          sx={styles.grn_table_expand_cell_grid}
        >
          <Grid
            item
            size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}
          >
            <Box sx={styles.grn_action_items_box}>
              <Typography sx={styles.grn_table_row_title}>
                Document Type :
              </Typography>
              <Typography sx={styles.grn_table_row}>
                {getDocTypeName(attachment.doctypecode || attachment.DOCTYPECODE)}
               
              </Typography>
            </Box>
          </Grid>
  <Grid item size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}>
      <Box sx={styles.grn_action_items_box}>
     {attachment.doctypeothername || attachment.DOCTYPEOTHERNAME ? (
  <Box sx={styles.grn_action_items_box}>
    <Typography sx={styles.grn_table_row_title}>
      Document Other Name :
    </Typography>
    <Typography sx={styles.grn_table_row}>
      {attachment.doctypeothername || attachment.DOCTYPEOTHERNAME}
    </Typography>
  </Box>
) : null}

      </Box>
    </Grid>
          <Grid
            item
            size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}
          >
            <Box sx={styles.grn_action_items_box}>
              <Typography sx={styles.grn_table_row_title}>
                Remark :
              </Typography>
              <Typography sx={styles.grn_table_row}>
                {attachment.docremark || attachment.REMARK || attachment.remark || "-"}
              </Typography>
            </Box>
          </Grid>

          <Grid
            item
            size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}
          >
            <Box sx={styles.grn_action_items_box}>
              <Typography sx={styles.grn_table_row_title}>
                Attachments :
              </Typography>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                bgcolor="background.paper"
                borderRadius={1}
                sx={{
                  boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.1)",
                }}
                p={1}
              >
                {isImage(attachment.FILEPATH || attachment.filename) ? (
                  <Tooltip
                    title={attachment.FILENAME || attachment.filename}
                    placement="bottom"
                  >
                    <img
                      src={
                        attachment.FILEPATH ||
                        attachment.fileUrl ||
                        (attachment.docpathjson &&
                          `data:image/png;base64,${attachment.docpathjson}`)
                      }
                      alt={attachment.FILENAME || attachment.filename}
                      style={{
                        width: 24,
                        height: 24,
                        objectFit: "cover",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setSelectedImage({
                          url:
                            attachment.FILEPATH ||
                            attachment.fileUrl ||
                            (attachment.docpathjson &&
                              `data:image/png;base64,${attachment.docpathjson}`),
                          name: attachment.FILENAME || "Image",
                          description: attachment.REMARK || "",
                        });
                        setImagePreviewOpen(true);
                      }}
                    />
                  </Tooltip>
                ) : (
                  <InsertDriveFileIcon
                    alt="Document icon"
                    style={{ width: 24, height: 24, cursor: "pointer" }}
                    onClick={() => {
                      setSelectedImage({
                        url:
                          attachment.FILEPATH ||
                          attachment.fileUrl ||
                          (attachment.docpathjson &&
                            `data:image/png;base64,${attachment.docpathjson}`),
                        name: attachment.FILENAME || "Document",
                        description: attachment.REMARK || "",
                      });
                      setImagePreviewOpen(true);
                    }}
                  />
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
      )
  )
) : (
  <Grid container spacing={2} sx={styles.grn_table_expand_cell_grid}>
    <Grid item size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}>
      <Box sx={styles.grn_action_items_box}>
        <Typography sx={styles.grn_table_row_title}>
          Document Type :
        </Typography>
        <Typography sx={styles.grn_table_row}> -</Typography>
      </Box>
    </Grid>

      <Grid item size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}>
      <Box sx={styles.grn_action_items_box}>
       
      </Box>
    </Grid>

    <Grid item size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}>
      <Box sx={styles.grn_action_items_box}>
        <Typography sx={styles.grn_table_row_title}>Remark :</Typography>
        <Typography sx={styles.grn_table_row}>-</Typography>
      </Box>
    </Grid>

    <Grid item size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}>
      <Box sx={styles.grn_action_items_box}>
        <Typography sx={styles.grn_table_row_title}>
          Attachments :
        </Typography>
        <Typography sx={styles.grn_table_row}>-</Typography>
      </Box>
    </Grid>
  </Grid>
)}

                        </Box>
                        <Divider />
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <ImagePopUp
        open={imagePreviewOpen}
        handleClose={() => setImagePreviewOpen(false)}
        image={selectedImage?.url}
        name={selectedImage?.name}
        description={selectedImage?.description}
      />
    </>
  );
};

export default  ViewDataGridGrnDetailsreturn;
